import moment from "moment";
import API from "../../../utils/helpers/API.helpers";
import { removeKeysWithNullValues } from "../../../utils/helpers/common.helpers";

const JadwalSidangService = {
  async getJadwalSidangs(term) {
    if (term) {
      return await API.get({ endpoint: `/jadwal-sidang/?term=${term}` });
    }
    return await API.get({ endpoint: "/jadwal-sidang/" });
  },
  async getJadwalSidangByMKSpesialId(mkspesialId) {
    return await API.get({
      endpoint: `/jadwal-sidang/?mk_spesial=${mkspesialId}`,
    });
  },
  async createJadwalSidang(jadwalSidangDetails) {
    let data = removeKeysWithNullValues(jadwalSidangDetails);
    data = parseJadwalSidangDetails(data);
    return await API.post({ endpoint: "/jadwal-sidang/", data: data });
  },
  async updateJadwalSidang(id, jadwalSidangDetails) {
    let data = removeKeysWithNullValues(jadwalSidangDetails);
    data = parseJadwalSidangDetails(jadwalSidangDetails);
    return await API.put({ endpoint: `/jadwal-sidang/${id}/`, data: data });
  },
  async deleteJadwalSidang(jadwalSidangId) {
    return await API.delete({ endpoint: `/jadwal-sidang/${jadwalSidangId}/` });
  },
  async getJadwalSidangsPublic(term, dosenId) {
    const params = {};
    if (term) params["term"] = term;
    if (dosenId) params["id_dosen"] = dosenId;
    return await API.get({
      endpoint: "/jadwal-sidang/public/",
      isWithoutAuth: true,
      params: params
    });
  },
};

const parseJadwalSidangDetails = (jadwalSidangDetails) => {
  if (jadwalSidangDetails.id) delete jadwalSidangDetails.id;
  console.log(jadwalSidangDetails)
  return {
    ...jadwalSidangDetails,
    mk_spesial: jadwalSidangDetails.mk_spesial.id,
    tanggal: moment.isMoment(jadwalSidangDetails.tanggal)
      ? jadwalSidangDetails.tanggal.format("DD-MM-YY")
      : moment(jadwalSidangDetails.tanggal, "YYYY-MM-DD").format("DD-MM-YY"),
    jam_mulai: moment.isMoment(jadwalSidangDetails.jam_mulai)
      ? jadwalSidangDetails.jam_mulai.format("HH:mm")
      : moment(jadwalSidangDetails.jam_mulai, "HH:mm:ss").format("HH:mm"),
    jam_selesai: moment.isMoment(jadwalSidangDetails.jam_selesai)
      ? jadwalSidangDetails.jam_selesai.format("HH:mm")
      : moment(jadwalSidangDetails.jam_selesai, "HH:mm:ss").format("HH:mm"),
    penguji: jadwalSidangDetails.penguji.map((dosen) => dosen.id_dosen),
    ruangan: jadwalSidangDetails.ruangan.id_ruangan,
    ketua_sidang: jadwalSidangDetails.ketua_sidang ? jadwalSidangDetails.ketua_sidang.id_dosen : "",
    ketua_penguji: jadwalSidangDetails.ketua_penguji ? jadwalSidangDetails.ketua_penguji.id_dosen : "",
  };
};

export default JadwalSidangService;
